module.exports = __webpack_public_path__ + "img/27.46d4216b.jpg";